import { Installment } from './Installment';

export interface CardInfo {
  cardType: string;
  cardBrand: string;
  installmentOptions: Installment[];
}

export const cardInfoFromResponse = (responseData: any): CardInfo => {
  const cardInfo = {
    cardType: responseData.cardType,
    cardBrand: responseData.cardBrand,
    installmentOptions: [{ value: 1, ratio: 0 }],
  };

  for (let i = 2; i <= 12; i++) {
    const ratio =
      responseData.installment?.[`M0_${String(i).padStart(2, '0')}`];
    if (ratio) {
      cardInfo.installmentOptions.push({ value: i, ratio: Number(ratio) });
    }
  }

  return cardInfo;
};
